module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};



//////////////////
// WEBPACK FOOTER
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/core-js/internals/create-property-descriptor.js
// module id = Pm8L
// module chunks = a74a